angular.module('tgaApp').service('settingsService', [
  '$http',
  'envService',
  'domainService',
  function ($http, envService, domainService) {
    const serverAddress = envService.read('serverAddress');
    let settings = null;

    function getSettings() {
      if (!settings) {
        settings = $http({
          method: 'GET',
          url: `${serverAddress}settings`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return settings;
    }

    function updateSettings(data) {
      settings = $http({
        method: 'PUT',
        url: `${serverAddress}settings`,
        data: {
          settings: data,
          domain: domainService.domain,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );

      return settings;
    }

    return {
      getSettings,
      updateSettings,
    };
  },
]);
